export const environment = {
	servicesUrl: {
		authentication: 'https://it-uat-connect-authentication.standards-t.com/',
		ballot: 'https://it-uat-connect-ballot.standards-t.com/',
		committee: 'https://it-uat-connect-committee.standards-t.com/',
		document: 'https://it-uat-connect-document.standards-t.com/',
		project: 'https://it-uat-connect-project.standards-t.com/',
	},
    internalSIMUrl: "https://sim-uat.standards.org.au/viewdocument/metadata/",
    salesForceAppLauncherUrl: 'https://standards--uat.sandbox.my.salesforce-sites.com/lightning/lightning.out.js',
    internalPCMSUrl: "https://standards--uat.sandbox.my.salesforce.com/idp/login?app=0sp4a000000002H",
    oktaIssuer: "https://id-uat.standards.org.au"
};
